import React, { useState, useEffect } from "react";
import { TextInput, Button, Label, Navbar } from "flowbite-react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../actions/auth";
import { Link, useNavigate } from "react-router-dom";
import NavbarVoltar from "../NavbarVoltar";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    loading,
    error: loginError,
    isAuthenticated,
  } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!formData.email || !formData.password) {
      setError("Por favor, preencha todos os campos.");
      return;
    }

    dispatch(login(formData.email, formData.password));
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/app/home");
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#fff1be] via-[#ee87cb] to-[#b060ff]">
      {/* Navbar */}
      <NavbarVoltar />
      {/* Card Container */}
      <div className="flex items-center justify-center min-h-[80vh]">
        <div className="bg-white shadow-lg rounded-3xl mx-2 px-8 py-10 max-w-md w-full">
          <h1 className="text-3xl font-bold text-center text-gray-900 mb-6">
            Bem-vindo de volta!
          </h1>
          <p className="text-center text-gray-600 mb-6">
            Que bom te ver por aqui! Entre com suas credenciais e continue sua
            jornada.
          </p>

          {/* Formulário de Login */}
          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* Email */}
            <div>
              <Label htmlFor="email" className="block mb-2">
                Email
              </Label>
              <TextInput
                id="email"
                name="email"
                type="email"
                placeholder="seu@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Senha */}
            <div>
              <Label htmlFor="password" className="block mb-2">
                Senha
              </Label>
              <TextInput
                id="password"
                name="password"
                type="password"
                placeholder="Digite sua senha"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            {/* Exibir Erros */}
            {error && <p className="text-red-500 text-sm">{error}</p>}
            {loginError && <p className="text-red-500 text-sm">{loginError}</p>}

            {/* Botão de Login */}
            <div>
              <Button
                type="submit"
                size="lg"
                className="w-full bg-black text-white hover:bg-gray-800 rounded-lg"
                disabled={loading}
              >
                {loading ? "Entrando..." : "Entrar"}
              </Button>
            </div>
          </form>

          {/* Termos e Cadastro */}
          <div className="mt-6 text-center text-sm text-gray-600 space-y-4">
            <p>
              Ao fazer login, você concorda com nossos{" "}
              <Link
                to="/termos"
                className="font-medium text-indigo-600 hover:underline"
              >
                Termos de Uso
              </Link>{" "}
              e{" "}
              <Link
                to="/politicas"
                className="font-medium text-indigo-600 hover:underline"
              >
                Políticas de Privacidade
              </Link>
              .
            </p>
            <p>
              Não tem uma conta? Cadastre-se{" "}
              <Link
                to="/cadastrar"
                className="font-medium text-indigo-600 hover:underline"
              >
                Clicando Aqui!
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
